import { render, staticRenderFns } from "./scoreLineSet.vue?vue&type=template&id=2ef172c8&scoped=true&"
import script from "./scoreLineSet.vue?vue&type=script&lang=js&"
export * from "./scoreLineSet.vue?vue&type=script&lang=js&"
import style0 from "./scoreLineSet.vue?vue&type=style&index=0&id=2ef172c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef172c8",
  null
  
)

export default component.exports